import type { AppStore } from "@/store/AppStore";
import { AiToolkitCollectionNotFoundError } from "@/modules/ai-toolkit/errors";
import type { GetCollectionInput, GetCollectionOutput } from "@mem-client/ai-toolkit/contract";
import {
  AiToolkitToolName,
  getCollectionInputSchema,
  getCollectionOutputSchema,
} from "@mem-client/ai-toolkit/contract";
import type { AiToolkitToolDefinition } from "@/modules/ai-toolkit/tools/types";
import { buildCollection } from "@/modules/ai-toolkit/tools/collections/collection-tools.helpers";

export const getCollection = async ({
  store,
  input,
}: {
  store: AppStore;
  input: GetCollectionInput;
}): Promise<GetCollectionOutput> => {
  const collection = await store.collections.getAsync(input.collectionId);

  if (!collection) {
    throw new AiToolkitCollectionNotFoundError({
      collectionId: input.collectionId,
    });
  }

  return {
    collection: await buildCollection({ collection }),
  };
};

export const getCollectionTool: AiToolkitToolDefinition<
  AiToolkitToolName.GetCollection,
  GetCollectionInput,
  GetCollectionOutput
> = {
  name: AiToolkitToolName.GetCollection,
  inputSchema: getCollectionInputSchema,
  outputSchema: getCollectionOutputSchema,
  strict: true,
  execute: getCollection,
};
